<template>
  <div class="content-wrapper conversation-container" style="margin-left: 0px !important">
    <div class="stage-panel-header">
      <div class="stage-panel-header__text">
        <span class="stage-panel-header__eyebrow">{{ isStartStage ? 'Start stage' : 'Editing stage' }}</span>
        <span class="stage-panel-header__name" :title="stageToEdit && stageToEdit.stageName">{{ isStartStage ? conversationType + ' details' : (stageToEdit && stageToEdit.stageName) }}</span>
      </div>
    </div>
    <!-- Main content -->
    <div class="stage-panel-body">
    <div class="col-xs-12 col-lg-12">
      <form role="form">
        <div v-if="stageToEdit.stageName === 'uninitialized'" class="stage-panel-card">
          <div class="stage-panel-card__title">{{ conversationType }} settings</div>
          <div class="row">
            <div class="flex-container">
              <div class="form-group flex-item">
                <label for="name">Name</label>
                <input type="text" @focus="handleFocus" @blur="handleBlur" v-model="config.name" class="form-control" id="name" :placeholder="conversationType +' name'" :disabled="isEdit || conversationName" />
                <span v-if="submitted && !$v.config.name.required" class="text-red pull-right">Please enter name.</span>
                <span v-if="submitted && !$v.config.name.conversationNameRegex" class="text-red pull-right"> The name can only contain underscore, dash and alphanumeric characters.</span>
              </div>
              <div class="form-group flex-item">
                <label for="type">Type</label>
                <nv-select v-if="isJourneyConversation" class="form-control" id="type" v-model="config.type" :disabled="isEdit">
                  <option value="journey">Journey</option>
                  <option value="journeyReminder">Journey of Reminder</option>
                </nv-select>
                <nv-select v-else class="form-control" id="type" v-model="config.type" :disabled="isEdit">
                  <option value="">--Select app type--</option>
                  <option value="screening">Screening</option>
                  <option value="nonscreening">Non Screening</option>
                  <option value="scoredresponse">Scored Response</option>
                  <option value="others">Others</option>
                </nv-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="flex-container">
              <div class="form-group flex-item">
                <label for="description">Description</label>
                <textarea @focus="handleFocus" @blur="handleBlur" v-model="config.description" rows="3" id="description" class="form-control" placeholder="Description" />
              </div>
              <div class="form-group flex-item">
                <div>
                  <label for="name">Topic/Context for NLP</label>
                  <treeselect 
                    id="topic" 
                    placeholder="--Choose NLP Topic--" 
                    :multiple="false" 
                    :options="nlpTopicList"
                    v-model="config.topic_id"
                  />
                </div>
                <div class="margin-top-10">
                  <label class="checkbox-inline referral-check-box">
                    <input type="checkbox" v-model="isReferralApp" />I am responsible for referrals
                  </label>
                </div>
              </div>
            </div>
          </div>
          <conversation-meta-data ref="conversationMetadata"
              :metaData="metaData"
              :countryAndLanguages="countryAndLanguages" />
        </div>
        <app-new-stage
          ref='selectedStage'
          v-on:stageReady="$emit('stageReady')"
          v-on:addStage="addStage"
          v-on:replace="replaceStage"
          v-on:getAllApps="getAllApps"
          :isJourneyStage="isJourneyConversation ? true : false"
          :stageDetails="stageToEdit"
          :allApps="formattedAllApps"
          :embeddedApps="formattedEmbeddedApps"
          :screeningMethods="screeningMethods"
          :isScreening="config.type ==='screening'"
          :conversationType="config.type"
          :currentConvo="config"
          :filteredApps="formattedFilteredApps"
          :filteredAppsForConvos="filteredAppsForConvos"
          :allConversations="allConversations"
          :allMethods="methodList"
          :functions="functionList"
          :metaData="metaData"
          :countryAndLanguages="countryAndLanguages" />
      </form>
    </div>
    </div>
    <div class="stage-panel-footer">
      <div class="stage-panel-warning" v-for="(msg, index) in missingStages.filter(item => stageToEdit.stageName === item.stage)" :key="index">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{msg.msgSet}}: {{msg.missingLang.join(', ')}} translation(s) missing
      </div>
      <div class="stage-panel-actions">
        <button :disabled="!actionable" @click="saveStage(false, undefined, true)" type="button" class="btn btn-default stage-panel-btn"
          v-bind:title="'Validate ' + conversationType + ' should \nonly be clicked at the end  \nonce you have completed \nadding ' + conversationType.toLowerCase() + ' details'">
          <i class="fa fa-check-circle" aria-hidden="true"></i> Validate &amp; Save {{conversationType}}
        </button>
        <button :disabled="!actionable" @click="saveStage(false, undefined)" type="button" class="btn btn-primary stage-panel-btn stage-panel-btn--primary">
          <i class="fa fa-floppy-o" aria-hidden="true"></i> Save Stage
        </button>
        <!-- Last and set apart: releasing replaces the live version on production -->
        <span class="stage-panel-actions__divider" aria-hidden="true"></span>
        <button v-on:click="handleDeployClick" type="button" class="btn stage-panel-btn stage-panel-btn--release" :title="'Replaces the live ' + conversationType.toLowerCase() + ' on production in every instance'">
          <i class="fa fa-rocket" aria-hidden="true"></i> Release to Production
        </button>
      </div>
    </div>
    <div class="modal-backdrop" v-if="showConfirmMessage" id="ConversationCopyAlert">
      <div class="modal modal-md" style="height: 200PX;max-width:800px">
        <div class="modal-header">
          <slot name="header">
            <h3>Alert</h3>
          </slot>
        </div>
        <div style="margin: 0px 20px">
          <slot name="body">
            <div>You are about to overwrite an existing {{conversationType.toLowerCase()}} with name <b>{{config.name}}</b> on <b>{{instanceWhereSameNameExist}}</b>. All the message sets will also be override. Do you want to continue?</div>
          </slot>
        </div>
        <div class="modal-footer" style="margin-top: auto; padding: 0px">
          <div class="form-group pull-right">
            <div class="col-sm-12">
              <button type="button" class="btn btn-default" @click="overrideConvNoClick">No, I’ll rename it</button>
              <button type="button" class="btn btn-primary" @click="overrideConvYesClick">Yes, copy & overwrite</button> 
            </div>
          </div>
        </div>
      </div>
    </div>
     <div class="modal-backdrop" v-if="(!showConfirmMessage) && showWarningMessage">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
        <div class="modal-header">
          <slot name="header">
            <h3>Warning</h3>
          </slot>
        </div>
          <div style="margin: 20px">
            <slot name="body">
              <div>There are some conversations/keyword linked with the app which you are trying to release. Please make sure to perform copy below apps in respective instance(s).</div>
              <div class="warning-text-red">Are you sure you want to proceed without these?</div>
              <div class="copy-warning-app-container">
                <div v-for="data in connectedAppDataForSync" :key="data.instanceName">
                  <div v-if="data.appsNotPresent.length || data.appsPresentButNeverDeployed.length || data.keywordsNotPresent.length">
                    <div style="font-weight: bold; margin-top: 15px">{{data.instanceName}}: </div>
                    <div class="copy-warning-text-div" v-if="data.appsPresentButNeverDeployed.length">
                      Conversation(s) present but never deployed:
                      <ul>
                        <li v-for="app in data.appsPresentButNeverDeployed" :key="app">
                          {{app}}
                        </li>
                      </ul>
                    </div>
                    <div class="copy-warning-text-div" v-if="data.appsNotPresent.length">
                      Conversation(s) not present:
                      <ul>
                        <li v-for="app in data.appsNotPresent" :key="app">
                          {{app}}
                        </li>
                      </ul>
                    </div>
                    <div class="copy-warning-text-div" v-if="data.keywordsNotPresent.length">
                        Keyword(s) not present:
                      <ul>
                        <li v-for="keyword in data.keywordsNotPresent" :key="keyword">
                          {{keyword}}
                        </li>
                      </ul>
                    </div>
                    <div class="copy-warning-text-div" v-if="data.messageTemplatesNotPresent.length">
                        Message Template(s) not present:
                      <ul>
                        <li v-for="template in data.messageTemplatesNotPresent" :key="template">
                          {{template}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </div>
          
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button type="button" class="btn btn-default" @click="CopyConversationWarningNoClick">No, let me check the conversation</button>
                <button type="button" class="btn btn-primary" @click="copyConversationWarningYesClick">Yes, proceed with it</button> 
              </div>
            </div>
          </div>
      </div>
    </div>

    <div class="modal-backdrop" v-if="showTranslationMissingMessage">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
        <div class="modal-header">
          <slot name="header">
            <h3>Warning</h3>
          </slot>
        </div>
          <div style="margin: 20px">
            <slot name="body">
              <div>Below are the stages missing mentioned translations:</div>
              <div class="copy-warning-app-container">
                <table width="100%">
                  <tr>
                    <th width="30%">Stage name</th>
                    <th width="30%">Message</th>
                    <th width="40%">Missing Translation(s)</th>
                  </tr>
                  <tr v-for="(item, index) in missingStages" :key='index'>
                    <td>{{item.stage}}</td>
                    <td>{{item.msgSet}}</td>
                    <td>{{item.missingLang.join(',  ')}}</td>
                  </tr>
                </table>
              </div>
              <div class="warning-text-red" style="margin-top: 20px;">Do you want to proceed with current configuration?</div>
            </slot>
          </div>
          
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button type="button" class="btn btn-default" @click="translationMissingWarningNoClick">No, let me check the conversation</button>
                <button type="button" class="btn btn-primary" @click="translationMissingWarningYesClick">Yes, proceed with it</button> 
              </div>
            </div>
          </div>
      </div>
    </div>

    <div class="modal-backdrop" v-if="showEmptyMessageSetError">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
        <div class="modal-header">
          <slot name="header">
            <h3>Error</h3>
          </slot>
        </div>
          <div style="margin: 20px">
            <slot name="body">
              <div>Below is the list of messages with no translation for this stage:</div>
              <div class="copy-warning-app-container">
                {{emptyMessageSets.join(', ')}}
              </div>
              <div class="warning-text-red" style="margin-top: 20px;">Please add at least one language translation for these messages, or remove them if you don't want them shown to users.</div>
            </slot>
          </div>
          
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary" @click="emptyMessageSetErrorOkClick">Ok, let me check</button> 
              </div>
            </div>
          </div>
      </div>
    </div>

    <BlockUI v-if="processing"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
  </div>
</template>

<script>
  import StageForm from './stage'
  import ConversationMetaData from './conversationMetadata'
  import api from '../../../utils/api'
  import { required, helpers } from 'vuelidate/lib/validators'
  import { standAloneApps } from '../../../config/constants'
  import { validateAllLanguageTranslation, validateMessageSet } from '../../../utils/utilities'

  // Regex to validate conversation name contains only alphanumerics, dash, underscore, and space
  const conversationNameRegex = helpers.regex('alpha', /^[a-zA-Z0-9 _-]*$/)

  export default {
    name: 'app-create-sms-app',
    props: ['stageToEdit', 'config', 'conversationName', 'isJourneyConversation', 'isStageEdited', 'buttonDialog', 'allConversations', 'metaData', 'folderName'],
    components: {
      'app-new-stage': StageForm,
      'conversation-meta-data': ConversationMetaData
    },
    validations: {
      config: {
        name: {
          required,
          conversationNameRegex
        }
      }
    },
    methods: {
      handleFocus () {
        // Perform actions when the text field or text area receives focus
        this.isNameAndDescriptionFocused = true
      },
      handleBlur () {
        // Perform actions when the text field or text area loses focus
        this.isNameAndDescriptionFocused = false
      },
      async isMessageSetEdited () {
        return await this.$refs.selectedStage.isMessageSetEdited()
      },
      getCurrentStageData () {
        return this.$refs.selectedStage.getCurrentStage()
      },
      saveStage (redirectAfterSave, nextRoute, isValidateConversation) {
        this.redirectAfterSave = redirectAfterSave
        this.nextRoute = nextRoute
        this.$refs.selectedStage.addOrUpdateStage(isValidateConversation)
      },
      overrideConvNoClick () {
        this.showConfirmMessage = false
      },
      overrideConvYesClick () {
        this.showConfirmMessage = false
        this.alredyConfirmedToOverirideFor = this.config.name
        this.save('uninitialized', false, this.isDeployClicked)
      },
      emptyMessageSetErrorOkClick () {
        this.showEmptyMessageSetError = false
      },
      getConversationMetadata () {
        let conversationMetadata = this.metaData
        console.log('this metadata1', conversationMetadata)
        if (this.stageToEdit.stageName === 'uninitialized') {
          conversationMetadata = {...conversationMetadata, ...this.$refs.conversationMetadata.getConversationMetadata()}
        }
        console.log('this metadata', conversationMetadata)
        if (this.$route.query.app && !(conversationMetadata && conversationMetadata.is_new_conversation)) this.is_new_conversation = false
        return { ...conversationMetadata, is_responsible_for_referrals: this.isReferralApp, is_new_conversation: this.is_new_conversation }
      },
      async checkexistance (name) {
        console.log('here')
        let appAlreadyExist = false
        if (this.config.name === this.alredyConfirmedToOverirideFor) return
        await api.buildRequest('checkexistance', 'POST', { name: name })
            .then(response => {
              if (response.status === 200 && response.data.payload.sameNameAppExist) {
                this.showConfirmMessage = true
                this.instanceWhereSameNameExist = response.data.payload.instanceName
                this.processing = false
                appAlreadyExist = true
              } else if (response.status === 200 && !response.data.payload.sameNameAppExist) {
                appAlreadyExist = false
              } else {
                this.$swal({
                  type: 'error',
                  message: response.data.payload.message
                })
                appAlreadyExist = false
              }
            }).catch(({response}) => {
              this.$swal({
                type: 'error',
                message: response.data.payload.message
              })
              this.processing = false
            })
        return appAlreadyExist
      },
      async save (savedStageName, isValidateConversation, isDeployClicked = false) {
        this.submitted = true
        this.$v.$touch()
        this.isDeployClicked = isDeployClicked
        this.config.name = this.config.name.trim()
        if (this.$v.$invalid) {
          return
        }
        if (this.config.stages[savedStageName] && this.config.stages[savedStageName].text) {
          let emptyMessageSets = []
          this.config.stages[savedStageName].text.forEach((item, index) => {
            if (!Object.keys(item).length) {
              emptyMessageSets.push(`Message ${index + 1}`)
            }
          })
          this.emptyMessageSets = emptyMessageSets
          if (this.emptyMessageSets.length) {
            this.showEmptyMessageSetError = true
            return
          }
        } else {
          this.emptyMessageSets = []
        }
        if (savedStageName === 'uninitialized') {
          this.metaData = this.getConversationMetadata()
        }
        this.processing = true
        if (this.conversationName !== this.config.name && (savedStageName === 'uninitialized' || !savedStageName)) {
          const appAlreadyExist = await this.checkexistance(this.config.name)
          if (appAlreadyExist) return
        }

        this.missingStages = validateAllLanguageTranslation(Object.values(this.config.stages))
        if (this.missingStages.length && isValidateConversation && !this.overrideTranslationMissing) {
          this.processing = false
          this.showTranslationMissingMessage = true
          return
        }
        let {resp, error} = validateMessageSet(Object.values(this.config.stages))
        if (!resp && error) {
          this.$swal(error)
          return
        }
        try {
          const response = await api.buildRequest('app', 'POST', { name: this.config.name, metaData: this.metaData, config: this.config, saveStage: !isValidateConversation, __v: 1 })
          this.appId = response.data.payload.id
          this.overrideTranslationMissing = false
          console.log('updated stage to edit', this.stageToEdit, this.appId)
          if (isDeployClicked) {
            if (response.status === 200) this.deploy()
            else {
              this.processing = false
              this.$swal({
                title: 'Release ' + this.conversationType,
                type: 'error',
                html: response.data.payload.message
              })
            }
          } else {
            this.$swal({
              title: isValidateConversation ? this.conversationType + ' Validated' : 'Save ' + this.conversationType,
              type: response.status === 200 ? 'success' : 'error',
              html: response.data.payload.message
            }).then(_response => {
              this.$emit('updateConfirmingSaveStage', false)
              if (this.redirectAfterSave) {
                this.$router.push({name: this.nextRoute})
              }
            })
            this.stageToEdit = Object.assign({}, {})
            this.processing = false
            this.$emit('updateTree', { name: this.config.name, metaData: this.metaData, config: this.config }, savedStageName)
          }
        } catch (error) {
          console.log(error)
          this.$swal({
            title: 'Save ' + this.conversationType,
            type: 'error',
            html: error.response.data.payload.message
          })
          this.processing = false
        }
      },
      CopyConversationWarningNoClick () {
        this.showWarningMessage = false
        this.allowDeployWithWarning = false
      },
      copyConversationWarningYesClick () {
        this.showWarningMessage = false
        this.allowDeployWithWarning = true
        this.deploy()
      },
      translationMissingWarningNoClick () {
        this.showTranslationMissingMessage = false
      },
      translationMissingWarningYesClick () {
        this.showTranslationMissingMessage = false
        this.overrideTranslationMissing = true
        this.missingStages = []
        this.save('uninitialized', true, this.isDeployClicked)
      },
      deploy () {
        this.processing = true
        let params = { config: this.config, __v: 1, metaData: this.getConversationMetadata(), allowDeployWithWarning: this.allowDeployWithWarning }
        if (this.folderName) {
          params.folderName = this.folderName
        }
        api.buildRequest('syncAppAcrossInstances', 'POST', params)
          .then(async response => {
            console.log('success', response.data)
            if (response.status === 206) {
              this.showWarningMessage = true
              this.connectedAppDataForSync = response.data.payload.data
            } else {
              if (response.status === 200) {
                try {
                  await api.buildRequest('llm-cache/invalidate', 'POST', {
                    type: 'conversation',
                    app_names: [this.config.name],
                    invalidate: true
                  })
                } catch (err) {
                  console.warn('Cache invalidation failed:', err.message)
                }
              }
              this.$swal({
                title: 'Deploy ' + this.conversationType,
                type: response.status === 200 ? 'success' : 'error',
                text: response.data.payload.message
              })
              this.allowDeployWithWarning = false
            }
            this.processing = false
          }).catch(({response}) => {
            console.log('fail')
            this.allowDeployWithWarning = false
            this.$swal({
              title: 'Deploy ' + this.conversationType,
              type: 'error',
              text: response.data.payload.message
            })
            this.processing = false
          })
      },
      async handleDeployClick () {
        if (await this.isStageEdited()) {
          const result = await this.buttonDialog('You have unsaved changes. Do you want to save the changes?', 'Save', `Don't save`)
          if (result.dismiss && result.dismiss === 'cancel') {
            this.save(null, true, true)
          } else {
            this.$refs.selectedStage.addOrUpdateStage(true, true)
          }
        } else {
          this.save(null, true, true)
        }
      },
      addStage (stage, stageName, isValidateConversation, isDeployClicked) {
        console.log('add stage configured', stageName, stage)
        if (!this.config.stages) this.config.stages = {}
        this.config.stages[stageName] = stage
        this.save(stageName, isValidateConversation, isDeployClicked)
      },
      getAllApps () {
        this.processing = true
        const url = 'app?deployed=true'
        api.buildRequest(url, 'GET')
          .then(({ status, data: { payload } }) => {
            if (status === 200) {
              let allApps = payload.apps.map(each => ({
                name: each.name,
                value: `GENERIC_SMS_APP###${each.name}`,
                _id: each.id,
                data: each.config,
                type: each.config && each.config.type,
                convoType: each.type
              }))
              let filteredApps = allApps
              filteredApps = filteredApps.concat([{ name: 'Unified Referral', value: 'APP_UNIFIED_REFERRAL' }])
              this.filteredApps = [...filteredApps]
              allApps = allApps.concat(standAloneApps)
              const excludedAppsForEmbeddedApps = ['WA_MIGRATE', 'SCOUT', 'APP_ANC', 'APP_ANC_UNSUBSCRIBE', 'APP_ANC_DUE_DATE_VERIFY', 'APP_PNC', 'APP_PNC_UNSUBSCRIBE', 'APP_PNC_BIRTH_DATE_VERIFY', 'END_CONVERSATION']
              const regexForEmbeddedApps = new RegExp(excludedAppsForEmbeddedApps.join('|'), 'i')
              this.embeddedApps = [...allApps.filter(item => !regexForEmbeddedApps.test(item.value))]
              this.embeddedApps = this.embeddedApps.filter(item => item.type !== 'journey' && item.type !== 'journeyReminder')
              this.allApps = [...allApps]
              this.processing = false
            }
          })
      },
      getMethodList () {
        const url = 'getMethodList'
        api.buildRequest(url, 'POST')
          .then(({ status, data: { payload } }) => {
            if (status === 200) {
              this.methodList = payload.reduce((map, cur, idx, orig) => {
                map[cur.shortname] = cur
                return map
              }, {})
            }
          })
      },
      async getFunctionList () {
        try {
          const response = await api.buildRequest('functions', 'GET')
          this.functionList = response.data.payload
        } catch (error) {
          return this.$swal({
            title: 'Failure',
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },
      async getNlpTopics () {
        try {
          const response = await api.buildRequest('getNlpTopics', 'GET')
          this.nlpTopicList = response.data.payload.map(item => { return { id: item.id, label: item.topic } })
        } catch (error) {
          return this.$swal({
            title: 'Failure',
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },
      async getScreeningMethods () {
        try {
          const response = await api.buildRequest('methods', 'POST', { offeringType: 'screening' })
          this.screeningMethods = response.data.payload.map(method => method.method_name)
        } catch (error) {
          return this.$swal({
            title: 'Failure',
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },
      async getLanguages () {
        await api.buildRequest('languages', 'GET').then(({ data }) => {
          this.countryAndLanguages = data.payload
        })
      },
      formatApps (data) {
        let apps = []
        if (!this.isNameAndDescriptionFocused && data && data.length > 0) {
          apps = data.map(app => {
            return { id: app.value, label: app.name, appId: app._id, data: app.data, convoType: app.convoType }
          })
        }
        return apps
      },
      replaceStage (stage, oldStageName, newStageName, isValidateConversation, isDeployClicked) {
        console.log('deleted stage configured', oldStageName)
        for (let stageName of Object.keys(this.config.stages)) {
          const stage = this.config.stages[stageName]
          if (stage['next']) {
            if (Array.isArray(stage['next']) && stage['next'].includes(oldStageName)) {
              stage['next'] = stage['next'].map(option => option !== oldStageName ? option : newStageName)
            } else if (stage['next'] === oldStageName) {
              stage['next'] = newStageName
            }
          }
        }
        delete this.config.stages[oldStageName]
        this.config.stages[newStageName] = stage
        // Passing saved stageName to point to same stage as stageToEdit prop from createOrUpdateJourney
        this.save(newStageName, isValidateConversation, isDeployClicked)
      },
      parseIsReferralApp (isReferralApp) {
        this.isReferralApp = isReferralApp
      }
    },
    data () {
      return {
        isNameAndDescriptionFocused: false,
        allApps: [],
        embeddedApps: [],
        methodList: [],
        stages: {},
        missingStages: [],
        showTranslationMissingMessage: false,
        overrideTranslationMissing: false,
        showEmptyMessageSetError: false,
        emptyMessageSets: [],
        appId: null,
        submitted: false,
        screeningMethods: [],
        processing: false,
        filteredApps: [],
        filteredAppsForConvos: [
          { name: 'Unified  ', value: 'APP_UNIFIED_REFERRAL' },
          { name: 'Location for Referral', value: 'APP_LOCATION' }
        ],
        functionList: [],
        nlpTopicList: [],
        nextRoute: '',
        redirectAfterSave: false,
        showConfirmMessage: false,
        alredyConfirmedToOverirideFor: '',
        isReferralApp: false,
        countryAndLanguages: {},
        is_new_conversation: true,
        instanceWhereSameNameExist: '',
        showWarningMessage: false,
        connectedAppDataForSync: [],
        allowDeployWithWarning: false,
        isDeployClicked: true
      }
    },
    watch: {
      metaData: function (value) {
        console.log('meta Value ', this.metaData, '\nValue', value)
        this.parseIsReferralApp(value.is_responsible_for_referrals)
      }
    },
    computed: {
      actionable () {
        return true
      },
      isEdit () {
        return this.$route.query.app
      },
      productionMode () {
        return process.env.NODE_ENV === 'production' && !window.location.href.includes('staging') && !window.location.href.includes('heroku')
      },
      conversationType () {
        return this.isJourneyConversation ? 'Journey' : 'Conversation'
      },
      isStartStage () {
        return !!this.stageToEdit && this.stageToEdit.stageName === 'uninitialized'
      },
      // Cached so switching stages doesn't hand the stage editor brand-new app lists, which re-ran its
      // watchers and rebuilt every app dropdown on each switch
      formattedAllApps () {
        return this.formatApps(this.allApps)
      },
      formattedEmbeddedApps () {
        return this.formatApps(this.embeddedApps)
      },
      formattedFilteredApps () {
        return this.formatApps(this.filteredApps)
      }
    },
    async mounted () {
      this.getAllApps()
      this.getMethodList()
      this.getScreeningMethods()
      this.getFunctionList()
      this.getNlpTopics()
      this.getLanguages()
    }
  }
</script>

<style scoped>
  .value {
    font-weight: bold;
  }
  .box-body {
    min-height: calc(100vh - 171px);
  }
  .form-loader img {
    width: 30px;
    height: 30px;
  }
  .action-button {
    clear: both;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .appsDiv {
    width: 100%;
    height: 100%;
    left: 50%;
    transform: translateX(0%);
  }
  .loader {
    z-index: 9999;
    background-color: transparent;
    position: fixed;
    transform: translate(-50%,-50%);
    top:50%;
    left:50%;
  }
  /* Header, scrolling form, and an action bar that stays in view. min-height overrides the
     inline one AdminLTE's layout fix puts on every .content-wrapper. */
  .conversation-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0 !important;
      margin: 0;
      overflow: hidden;
      width: 100%;
      background: #FFFFFF;
  }
  .stage-panel-header {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 20px;
    border-bottom: 1px solid #E2E8F0;
    background: #FFFFFF;
  }
  .stage-panel-header__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .stage-panel-header__eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8896A5;
  }
  .stage-panel-header__name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: #1E3A5F;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .stage-panel-body {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 16px 0 24px;
  }
  .stage-panel-body > .col-xs-12 {
    float: none;
    min-width: 400px;
  }
  .stage-panel-card {
    margin-bottom: 16px;
    padding: 16px 16px 4px;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
    background: #FFFFFF;
    box-shadow: 0 4px 20px -4px rgba(29, 40, 58, 0.08);
  }
  .stage-panel-card__title {
    margin-bottom: 12px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #1E3A5F;
  }
  .stage-panel-footer {
    flex-shrink: 0;
    padding: 10px 20px;
    border-top: 1px solid #E2E8F0;
    background: #FFFFFF;
    box-shadow: 0 -4px 16px -8px rgba(30, 58, 95, 0.15);
  }
  .stage-panel-warning {
    margin-bottom: 8px;
    padding: 6px 10px;
    border-radius: 8px;
    background: #FCE8EB;
    color: #C94455;
    font-size: 13px;
  }
  .stage-panel-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
  }
  .stage-panel-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 16px;
    font-weight: 600;
  }
  .stage-panel-btn--primary {
    min-width: 140px;
    justify-content: center;
  }
  .stage-panel-actions__divider {
    align-self: stretch;
    width: 1px;
    margin: 4px 4px;
    background: #E2E8F0;
  }
  .stage-panel-btn--release {
    background: #E05263;
    border-color: #E05263;
    color: #FFFFFF;
    box-shadow: 0 2px 8px -2px rgba(224, 82, 99, 0.45);
  }
  .stage-panel-btn--release:hover,
  .stage-panel-btn--release:focus {
    background: #C94455;
    border-color: #C94455;
    color: #FFFFFF;
  }
  .referral-check-box{
    font-weight: bold;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// conversationPanel.vue?987ba6ec